const initialState = {
  loading: true,
  localLoading: true,
  updatedAt: null,
  // datetime: new Date().toString(),
  datetime: null,
  updatedValueIds: [],
  isOnline: true,
  offlineQueue: [],
  pendingConflicts: [],
};

export const app = (state = initialState, action) => {
  // console.log('updating app store!!!!')
  switch (action.type) {
    case "app/updated_at":
      return {
        ...state,
        updatedAt: action.updatedAt,
      };
    case "app/loading":
      console.log(`loading: ${action.loading}`);
      return {
        ...state,
        loading: action.loading,
      };
    case "app/local_loading":
      return {
        ...state,
        localLoading: action.localLoading,
      };
    case "app/datetime":
      return {
        ...state,
        datetime: action.datetime,
      };
    case "app/updated_value_ids":
      return {
        ...state,
        // updatedValueIds: [
        //   ...state.updatedValueIds,
        //   ...action.updatedValueIds,
        // ],
        updatedValueIds: action.updatedValueIds,
      };
    case "app/set_online":
      return { ...state, isOnline: action.isOnline };
    case "app/set_offline_queue":
      return { ...state, offlineQueue: action.queue };
    case "app/add_conflict":
      return { ...state, pendingConflicts: [...state.pendingConflicts, action.conflict] };
    case "app/resolve_conflict":
      return { ...state, pendingConflicts: state.pendingConflicts.filter((c) => c.id !== action.id) };
    default:
      return state;
  }
};
